<ion-header *ngIf="!isEmbeddedPage" class="ion-no-border">
  <ng-container [ngSwitch]="theme">
    <ng-container *ngSwitchCase="pageTheme.shell">
      <air-theme-header></air-theme-header>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <air-header></air-header>
    </ng-container>
  </ng-container>
</ion-header>

<ion-content
  [scrollEvents]="true"
  [class.searchActive]="searchActivated"
  [ngClass]="{ 'embedded-page__content': isEmbeddedPage }"
  #ionContent
>
  <air-search-results-box></air-search-results-box>
  <div class="fixed-box">
    <main class="main">
      <router-outlet></router-outlet>
    </main>
    <air-footer *ngIf="!isEmbeddedPage" [hidden]="!isFooterVisible"></air-footer>
  </div>
  <resize-detector></resize-detector>
</ion-content>

<air-cookie-banner slot="fixed" *ngIf="!isNativeMobile"></air-cookie-banner>
<air-mobile-navigation slot="fixed"></air-mobile-navigation>
<air-toasts slot="fixed"></air-toasts>
<air-my-card-sheet slot="fixed" *ngIf="isMobile"></air-my-card-sheet>
<air-app-consent-sheet slot="fixed" *ngIf="isNativeMobile"></air-app-consent-sheet>
<ng-template slot="fixed" modalAnchor></ng-template>
